import { render, staticRenderFns } from "./QuizCard.vue?vue&type=template&id=63478ff2&scoped=true"
import script from "./QuizCard.vue?vue&type=script&lang=js"
export * from "./QuizCard.vue?vue&type=script&lang=js"
import style0 from "./QuizCard.vue?vue&type=style&index=0&id=63478ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63478ff2",
  null
  
)

export default component.exports